export const getCourseByname = (data, name = "") => {
  if (name === "") {
    return [];
  }

  name = name.toLocaleLowerCase();


  return data.courses?.filter(course => course.name.toLocaleLowerCase().includes(name));
};


//Update to this
export const getCourseByName = (data, name = "") => {
  if (name === "") {
    return [];
  }

  name = name.toLocaleLowerCase();


  return data?.filter(course => course.name.toLocaleLowerCase().includes(name));
};
